import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Icon, Intent, InputGroup } from '@blueprintjs/core';

import Clearfix from 'components/elements/clearfix';
import { IconNames } from '@blueprintjs/icons';
import { createForm } from 'rc-form';
import moment from 'moment';
import styled from 'styled-components';
//* ------------------------ */
import IconRequired from 'components/elements/required-icon';
import FacilitySelect from 'components/elements/select-facility';
import DateInput from 'components/elements/date-input';
import { DATE_FORMAT, COLOR } from 'config';
import { convertDateFromSever as convertDate } from 'utils/fnUtil';
// import dynamicRoleHOC from 'hoc/dynamicRole';
import YearSelect from 'components/elements/select-year';
import WasteProfile from './waste-profile';
import _ from 'lodash';
import { IS_ENTERPRISE } from 'config';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

class EnvironmentProtectionWorkForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    handelSubmit: PropTypes.func,
  };

  setInitialValue(keyPath, defaultValue, type = '') {
    let value = _.result(this.props.initialValue, keyPath, defaultValue);
    if (value) {
      switch (type) {
        case 'Chemistries':
          const data = _.map(value, (item) => {
            const chemistry = [];
            if (item.chemistryType) {
              chemistry.push({
                ...item.chemistryType,
                value: item.chemistryType._id,
              });
            }
            if (item.chemistry) {
              chemistry.push({
                ...item.chemistry,
                value: item.chemistry._id,
              });
            }

            return {
              key: item.key,
              moreInfo: item.moreInfo,
              chemistry: chemistry,
            };
          });
          return data;

        case 'select':
          return {
            value: value._id,
            label: value.Name ? value.Name : value.FacilityNameFull,
            obj: value,
          };
        case 'date':
          return moment(value).format();
        case 'dates':
          return `${moment(value[0]).format()} - ${moment(value[1]).format()}`;
        default:
          return value;
      }
    }

    return value;
  }

  submit = () => {
    this.props.form.validateFields((error, value) => {
      if (error) return;

      value.facility = _.get(value.facility, 'value');
      value.YearReport = _.get(value.YearReport, 'value', null);
      if (value.Chemistries) {
        value.Chemistries = _.map(value.Chemistries, (item) => {
          return {
            ...item,
            chemistryType: item.chemistry
              ? _.get(item.chemistry[0], 'value', null)
              : null,
            chemistry: item.chemistry
              ? _.get(item.chemistry[1], 'value', null)
              : null,
          };
        });
      }
      // console.log(value, '--submit--');
      if (this.props.handelSubmit) this.props.handelSubmit(value);
    });
  };

  renderInfoFacility = () => {
    const { getFieldValue } = this.props.form;

    let info = getFieldValue('facility');
    if (info) {
      info = info.obj;
    }

    return (
      <React.Fragment>
        <Clearfix height={8} />
        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                <LabelContainer>Tên doanh nghiệp</LabelContainer>
              </Col>
              <Col xs={4}>
                <InputGroup
                  disabled
                  value={_.get(info, 'organizationName', '')}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
          </React.Fragment>
        )}
        <Row>
          <Col xs={4}>
            <LabelContainer>Địa chỉ</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup disabled value={_.get(info, 'Address1', '')} />
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  render() {
    const { getFieldError, getFieldProps } = this.props.form;
    return (
      <div>
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          BC Công tác BVMT
        </h4>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={this.submit}
                style={{ color: COLOR.SUCCESS }}
              />
              <Clearfix width={8} />
              {/* <Link to={this.props.slugBack ? this.props.slugBack : slug.BASE}> */}
              <Icon
                onClick={() => {
                  window.history.back();
                }}
                icon={IconNames.DISABLE}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.DANGER}
              />
              {/* </Link> */}
            </HeaderContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              <b>Thông tin chung</b>
            </LabelContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Tên cơ sở/dự án
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <FacilitySelect
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'facility',
                option: {
                  initialValue: this.setInitialValue(
                    'facility',
                    null,
                    'select'
                  ),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn tên cơ sở/dự án',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('facility') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        {this.renderInfoFacility()}
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Năm báo cáo</LabelContainer>
          </Col>
          <Col xs={4}>
            <YearSelect
              placeholder='Năm báo cáo'
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'YearReport',
                option: {
                  initialValue: this.setInitialValue('YearReport')
                    ? {
                        value: this.setInitialValue('YearReport'),
                        label: this.setInitialValue('YearReport'),
                      }
                    : null,
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ngày nộp</LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày nộp'
              {...getFieldProps('DateFiling', {
                initialValue: convertDate(
                  this.setInitialValue('DateFiling', null)
                ),
              })}
            />
          </Col>
        </Row>

        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              <b>Hồ sơ chất thải</b>
            </LabelContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col>
            <WasteProfile
              {...getFieldProps('Chemistries', {
                initialValue: this.setInitialValue(
                  'Chemistries',
                  null,
                  'Chemistries'
                ),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng chọn ít nhất một loại chất thải',
                  },
                ],
              })}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}></Col>
          <Col xs={4}>
            <ErrorContainer>
              {(getFieldError('Chemistries') || []).join(', ')}
            </ErrorContainer>{' '}
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              <b>Chứng từ xử lý chất thải</b>
            </LabelContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Chứng từ nguồn thải</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Chứng từ nguồn thải'
              min={0}
              max={360}
              {...getFieldProps('LicenseWasteSources', {
                initialValue: this.setInitialValue('LicenseWasteSources', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Chứng từ vận chuyển</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Chứng từ vận chuyển'
              min={0}
              max={360}
              {...getFieldProps('LicenseTransport', {
                initialValue: this.setInitialValue('LicenseTransport', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Chứng từ xử lý chất thải</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Chứng từ xử lý chất thải'
              min={0}
              max={360}
              {...getFieldProps('LicenseWasteTreatment', {
                initialValue: this.setInitialValue('LicenseWasteTreatment', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              <b>Kết quả khắc phục theo yêu cầu </b>
            </LabelContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Kết quả khắc phục</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Kết quả khắc phục'
              min={0}
              max={360}
              {...getFieldProps('ResultFix', {
                initialValue: this.setInitialValue('ResultFix', ''),
              })}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default createForm()(EnvironmentProtectionWorkForm);



// WEBPACK FOOTER //
// ./src/containers/environment-protection-work/environment-protection-work-Form/index.js